import { WorkflowStageIcon } from 'shared/domain/workflow/types';

export const WORKFLOW_STAGE_ICONS = Object.values(WorkflowStageIcon);
